<ng-container
  *ngIf="{
    loading: loading$ | async,
    breadcrumbs: breadcrumbs$ | async,
  } as obs"
>
  @if (obs.loading || obs.breadcrumbs === null) {
    <div class="breadcrumbs skeleton"></div>
  }

  @if (!obs.loading && obs.breadcrumbs) {
    <nav aria-label="Breadcrumbs" data-analytics="breadcrumbs">
      @for (crumb of obs.breadcrumbs; track crumb.label; let i = $index) {
        @if (i !== obs.breadcrumbs.length) {
          <div class="divider text-c1-l-500">
            @if (i !== obs.breadcrumbs.length - 1) {
              <a [routerLink]="crumb.link">
                <span>{{ crumb.label }}</span>
              </a>
            } @else {
              <span class="text-c1-l-700">{{ crumb.label }}</span>
            }

            @if (i !== obs.breadcrumbs.length - 1) {
              <sd-icon type="arrow-right"></sd-icon>
            }
          </div>
        }
      }
    </nav>
  }
</ng-container>
